export default __webpack_public_path__ + "static/media/1622.bf7f63ae.png";